import DetailField from "../../components/DetailField";
import {
  Transaction,
  TransactionDetail,
} from "../../services/transactionsService";
import Panel from "../customerSettings/Panel";

export type Props = {
  transaction?: Transaction | null;
  transactionDetail?: TransactionDetail | null;
  isACHTransaction: boolean;
  isLoading?: boolean;
};

function TransactionPaymentFee({
  transaction,
  transactionDetail,
  isACHTransaction,
  isLoading = false,
}: Props): JSX.Element {
  let pendingEODReport: boolean | undefined = true;
  if (
    process.env.REACT_APP_FF_DISPLAY_ICPP_SURCHARGE?.toLocaleLowerCase() ===
    "true"
  ) {
    pendingEODReport =
      transactionDetail?.useInterchangeRate &&
      transactionDetail?.technologyFee === "0.00" &&
      transactionDetail?.interchangeFeeAmount === "0.00";
  } else {
    pendingEODReport =
      transactionDetail?.useInterchangeRate &&
      transactionDetail?.technologyFee === "0.00" &&
      transactionDetail?.convenienceFeeAmount === "0.00";
  }

  const showInterchangeLabels =
    transactionDetail?.useInterchangeRate && isACHTransaction === false;

  function getProcessingFeesLabel() {
    if (showInterchangeLabels) return "Markup Fee";
    if (transaction?.paymentMethod === "ach") {
      return "ACH Processing Fees";
    }
    if (transaction?.paymentMethod.toLowerCase() === "eft_directdebit_ca")
      return "EFTPAD Processing Fees";
    return "Credit Card Processing Fees";
  }

  return (
    <Panel className="my-2 w-full rounded-lg border border-gray-200 shadow-sm md:w-[49%]">
      <Panel.Header title="Payment Fees" className="rounded-b-none" />
      <Panel.Content>
        <div className="flex flex-col gap-x-4 gap-y-4 py-4 px-2">
          {pendingEODReport ? (
            <div>Pending EOD Report.</div>
          ) : (
            <>
              <DetailField label="Type" isLoading={isLoading} variant="start">
                {showInterchangeLabels ? "Interchange Fee" : "Technology Fees"}
              </DetailField>
              <DetailField label="Amount" isLoading={isLoading} variant="start">
                {transaction?.amountCurrency} {transactionDetail?.technologyFee}
              </DetailField>
              <hr />
              {process.env.REACT_APP_FF_DISPLAY_ICPP_SURCHARGE?.toLocaleLowerCase() ===
                "true" && showInterchangeLabels ? (
                <>
                  {transactionDetail?.interchangeFeeAmount !== "0.00" && (
                    <>
                      <DetailField
                        label="Type"
                        isLoading={isLoading}
                        variant="start"
                      >
                        Card Network Fee
                      </DetailField>
                      <DetailField
                        label="Amount"
                        isLoading={isLoading}
                        variant="start"
                      >
                        {transaction?.amountCurrency}{" "}
                        {transactionDetail?.interchangeFeeAmount}
                      </DetailField>
                      <hr />
                    </>
                  )}
                  <DetailField
                    label="Type"
                    isLoading={isLoading}
                    variant="start"
                  >
                    {transactionDetail?.interchangeFeeAmount === "0.00"
                      ? "Card Network Fee"
                      : "Surcharges"}
                  </DetailField>
                  <DetailField
                    label="Amount"
                    isLoading={isLoading}
                    variant="start"
                  >
                    {transaction?.amountCurrency}{" "}
                    {transactionDetail?.convenienceFeeAmount}
                  </DetailField>
                </>
              ) : (
                <>
                  <DetailField
                    label="Type"
                    isLoading={isLoading}
                    variant="start"
                  >
                    {showInterchangeLabels ? "Card Network Fee" : "Surcharges"}
                  </DetailField>
                  <DetailField
                    label="Amount"
                    isLoading={isLoading}
                    variant="start"
                  >
                    {transaction?.amountCurrency}{" "}
                    {transactionDetail?.convenienceFeeAmount}
                  </DetailField>
                </>
              )}
              <hr />
              <DetailField label="Type" isLoading={isLoading} variant="start">
                {getProcessingFeesLabel()}
              </DetailField>
              <DetailField label="Amount" isLoading={isLoading} variant="start">
                {transaction?.amountCurrency}{" "}
                {transactionDetail?.creditCardProcessingFeeAmount}
              </DetailField>
              <hr />
              <DetailField label="Type" isLoading={isLoading} variant="start">
                Transaction Fees
              </DetailField>
              <DetailField label="Amount" isLoading={isLoading} variant="start">
                {transaction?.amountCurrency}{" "}
                {transactionDetail?.transactionFeeAmount}
              </DetailField>
            </>
          )}
        </div>
      </Panel.Content>
    </Panel>
  );
}

export default TransactionPaymentFee;
